import React from "react";
import { Stack, Skeleton, Typography, IconButton } from "@mui/material";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import moment from "moment-timezone";
import { useI18nLanguage } from "../../hooks/i18nLanguage";

interface DateNavigationHeaderProps {
  selectedDate?: number;
  isLoading: boolean;
  disablePrev: boolean;
  disableNext: boolean;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  showNavigation?: boolean;
}

export const DateNavigationHeader: React.FC<DateNavigationHeaderProps> = ({
  selectedDate,
  isLoading,
  disablePrev,
  disableNext,
  onPreviousWeek,
  onNextWeek,
  showNavigation = true
}) => {
  const { selectedLanguageForMoment } = useI18nLanguage();
  return (
    <Stack
      minHeight="55px"
      alignItems="center"
      justifyContent="flex-start"
      direction="row"
      pl={2}
      width="100%"
    >
      <Stack direction="row">
        {!isLoading ? (
          <>
            <Typography fontSize={16} fontWeight={500}>
              {moment(selectedDate)
                .startOf("week")
                .locale(selectedLanguageForMoment)
                .format("MMM")}{" "}
              {moment(selectedDate).startOf("week").format("DD")}
              {" - "}
              {moment(selectedDate)
                .startOf("week")
                .endOf("week")
                .locale(selectedLanguageForMoment)
                .format("MMM")}{" "}
              &nbsp;
              {moment(selectedDate).startOf("week").endOf("week").format("DD")}
            </Typography>{" "}
            <Typography fontSize={16} fontWeight={500} color="textSecondary">
              {moment().add(6, "day").format(", YYYY")}
            </Typography>
          </>
        ) : (
          <>
            <Skeleton
              variant="rounded"
              width="55px"
              height="20px"
              sx={{ mr: 1 }}
            />
            <Skeleton
              variant="rounded"
              width="55px"
              height="20px"
              sx={{ mr: 1 }}
            />
            <Skeleton
              variant="rounded"
              width="35px"
              height="20px"
              sx={{ mr: 3 }}
            />
            <Skeleton
              variant="rounded"
              width="30px"
              height="20px"
              sx={{ mr: 2 }}
            />
            <Skeleton
              variant="rounded"
              width="30px"
              height="20px"
              sx={{ mr: 1 }}
            />
          </>
        )}
      </Stack>
      {showNavigation && !isLoading && (
        <Stack pl={1} gap={1} direction="row" zIndex={200}>
          <IconButton
            aria-label="previous week"
            size="small"
            onClick={onPreviousWeek}
            disabled={disablePrev}
          >
            <KeyboardArrowLeftOutlinedIcon />
          </IconButton>
          <IconButton
            aria-label="next week"
            size="small"
            onClick={onNextWeek}
            disabled={disableNext}
          >
            <KeyboardArrowRightOutlinedIcon />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
};
